import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    status: "",
    token: null, //localStorage.getItem("token") || "",
    user: null,
    token_issued_at: Date.now(),
    loading: false
  },
  mutations: {
    auth_request(state) {
      state.status = "loading";
    },
    auth_success(state) {
      state.status = "success";
    },
    auth_error(state) {
      state.status = "error";
    },
    set_token(state, token) {
      state.token = token;
    },
    set_token_issued_at(state, token_issued_at) {
      state.token_issued_at = token_issued_at;
    },
    set_user(state, user) {
      state.user = user;
    },
    logout(state) {
      state.status = "";
      state.token = null;
    },
    setLoading(state, loading) {
      state.loading = loading;
    }
  },
  actions: {
    logout({
      commit
    }) {
      return new Promise((resolve /*, reject*/ ) => {
        commit("logout");
        localStorage.clear();
        delete axios.defaults.headers.common["Authorization"];
        resolve();
      });
    }
  },
  getters: {
    isLoggedIn: state => !!state.token,
    authStatus: state => state.status,
    token: state => state.token,
    user: state => state.user,
    isLoading: state => state.loading,
    token_valid: state =>
      state.token ? (Date.now() - state.token_issued_at) / 1000 < state.token.expires_in : false
  },
  plugins: [createPersistedState()]
});